<app-alert-detalhe-rota [alertDetalheRota]="showAlertRota" [dadosRota]="dadosDetalheRota" (alertRotaFechou)="fecharAlertFatura($event)"></app-alert-detalhe-rota>

<div class="body-alert">
  <div class="div-alert" [ngClass]="{'altura-menor': dadosRoteirizacao === null}">
    <p class="titulo-alert">
      Rota Inteligente
      <button
        class="btn-icon"
        (click)="printRotaInteligente()"
        aria-label="Baixar rota inteligente"
        style="float: right; padding-right: 30px;">
        <i class="fa fa-download" aria-hidden="true"></i>
      </button>
    </p>
    <p class="subtitulo-alert">Confirma os dados antes da aprovação</p>
    @if (dadosRoteirizacao) {
      <div class="div-informacoes">
        <div class="row">
          <div class="col-3">
            <span class="label">Matrícula</span>
            <p class="paragrafo">{{dadosRoteirizacao.matricula}}</p>
          </div>
          <div class="col-6">
            <span class="label">Nome do Usuário</span>
            <p class="paragrafo">{{dadosRoteirizacao.nomeUsuario}}</p>
          </div>
          <div class="col-3">
            <span class="label">Departamento</span>
            <p class="paragrafo">{{dadosRoteirizacao.departamento}}</p>
          </div>
          <div class="col-3">
            <span class="label">Status Rota</span>
            <p class="paragrafo">{{dadosRoteirizacao.statusRota}}</p>
          </div>
          <div class="col-3">
            <span class="label">Status Produto</span>
            <p class="paragrafo">{{dadosRoteirizacao.statusProduto}}</p>
          </div>
          <div class="col-6">
            <span class="label">Data/hora</span>
            <p class="paragrafo">{{dadosRoteirizacao.dataHora.slice(0,10) | appDate: 'dd/MM/yyyy'}} - {{dadosRoteirizacao.dataHora.slice(11,16)}}</p>
          </div>
          <div class="col-12 mt-3">
            <span class="label">Endereço de Trabalho</span>
            <p class="paragrafo">{{dadosRoteirizacao.enderecoTrabalho}}</p>
          </div>
          <div class="col-12 mt-3">
            <span class="label">Endereço de Residência</span>
            <p class="paragrafo">{{dadosRoteirizacao.enderecoResidencia}}</p>
          </div>
          <div class="col-12 mt-3">
            <span class="label">Percurso Ida da Residência ao Trabalho</span>
            @for (percurso of dadosRoteirizacao.listaPercursoIda; track percurso) {
              <div class="w-100 mt-2">
                <p class="instrucao">{{percurso.ordem}} {{percurso.instrucao}}</p>
                <p class="instrucao-detalhe">{{percurso.instrucaoDetalhe}} - {{percurso.tempoEstimado}}</p>
              </div>
            }
          </div>
          <div class="col-12 mt-3">
            <span class="label">Percurso Volta do Trabalho a Residência</span>
            @for (percurso of dadosRoteirizacao.listaPercursoVolta; track percurso) {
              <div class="w-100 mt-2">
                <p class="instrucao">{{percurso.ordem}} {{percurso.instrucao}}</p>
                <p class="instrucao-detalhe">{{percurso.instrucaoDetalhe}} - {{percurso.tempoEstimado}}</p>
              </div>
            }
          </div>
          <div class="col-12 mt-3">
            <span class="label">Lista de Vale Transportes</span>
            @for (valeTransporte of dadosRoteirizacao.listaValeTransporte; track valeTransporte) {
              <div class="w-100 mt-2">
                <p class="instrucao">{{valeTransporte.codigo}} - {{valeTransporte.descricao}}</p>
                <p class="instrucao-detalhe">Qtde: {{valeTransporte.quantidade}} - R$: {{valeTransporte.valorUnitario}} | Valor total R$: {{valeTransporte.subTotal}}</p>
              </div>
            }
          </div>
        </div>
      </div>
    }

    @if (dadosRoteirizacao === null) {
      <div class="mt-3">
        <div class="text-center">
          <output class="spinner-border c-primary">
            <span class="visually-hidden">Consultando dados da Roteirização ...</span>
          </output>
        </div>
        <p class="legenda-spinner">Consultando dados da Roteirização ...</p>
      </div>
    }

    @if (dadosRoteirizacao === false) {
      <div class="text-center">
        <img src="/assets/img/erro.png" width="230px" alt="Erro">
        <p class="legenda-erro">Ocorreu um erro na consulta de dados da Roteirização.</p>
      </div>
    }

    @if (dadosRoteirizacao) {
      <div class="footer-alert">
        @if (dadosRoteirizacao.botaoAprovar) {
          <button class="botao-secundario me-3" (click)="fecharAlertRefazerRota('aprovar')">APROVAR</button>
        }
        @if (!dadosRoteirizacao.botaoAprovar) {
          <button class="botao-secundario me-3 disabled" disabled>APROVAR</button>
        }
        <button class="botao-secundario-outline" (click)="fecharAlertRefazerRota('fechar')">FECHAR</button>
      </div>
    }

    @if (dadosRoteirizacao === true) {
      <div class="class-footer-alert">
        <button class="botao-secundario-outline" (click)="fecharAlertRefazerRota('fechar')">FECHAR</button>
      </div>
    }
  </div>
</div>
